/* HHD cart sync - original code. Keeps add-on fee lines (property _hhd_parent) at the same
   quantity as their design line (property _hhd_group); removes orphans; locks add-on qty inputs. */
(function(){
  'use strict';
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/', busy=false;
  function sync(){
    if(busy) return; busy=true;
    fetch(root+'cart.js').then(function(r){return r.json();}).then(function(cart){
      var parents={}, updates={}, changed=false;
      cart.items.forEach(function(it){var g=it.properties&&it.properties._hhd_group;if(g)parents[g]=(parents[g]||0)+it.quantity;});
      cart.items.forEach(function(it){var p=it.properties&&it.properties._hhd_parent;if(!p)return;
        var want=parents[p]||0; if(it.quantity!==want){updates[it.key]=want;changed=true;}});
      if(!changed){lock(cart);busy=false;return;}
      return fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:updates})})
        .then(function(){window.location.reload();});
    }).catch(function(){busy=false;});
  }
  function lock(cart){ // add-on rows: no manual qty / remove controls
    cart.items.forEach(function(it,i){ if(!(it.properties&&it.properties._hhd_parent)) return;
      var row=document.getElementById('CartItem-'+(i+1)); if(!row) return;
      row.querySelectorAll('quantity-input, cart-remove-button').forEach(function(x){x.style.display='none';});
      row.classList.add('hhd-addon-line');
    });
  }
  document.addEventListener('DOMContentLoaded',sync);
  var items=null, t=null;
  function watch(){items=document.querySelector('cart-items');if(!items)return;
    new MutationObserver(function(){clearTimeout(t);t=setTimeout(sync,600);}).observe(items,{childList:true,subtree:true});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',watch);else watch();
})();
